module.exports = __webpack_public_path__ + "site/img/45.01917671.jpg";